import React, { useEffect, useState } from 'react';
import { Menu, X, Globe } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
const LOGO_DEFAULT = 'https://cdn.magicpatterns.com/uploads/guu75Bs7Tjxnk8JqJWnwYN/Logo.png';
const LOGO_HERO = 'https://cdn.magicpatterns.com/uploads/v9Gs3SaD1y6ESKVtb3Njoy/Content_(1).png';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const {
    language,
    setLanguage,
    t
  } = useLanguage();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: t.header.ecommerceProblem,
    href: '#ecommerce-problem'
  }, {
    name: t.header.whyTokoteta,
    href: '#why-different'
  }, {
    name: t.header.howItWorks,
    href: '#how-it-works'
  }, {
    name: t.header.communityStories,
    href: '#community-stories'
  }];
  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'id' : 'en');
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-153">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-154">
        <div className="flex justify-between items-center" data-id="element-155">
          {/* Logo - swaps based on scroll state */}
          <div className="flex items-center" data-id="element-156">
            <a href="#" className="flex items-center gap-2" data-id="element-157">
              <img src={isScrolled ? LOGO_DEFAULT : LOGO_HERO} alt="Tokoteta Logo" className="h-8 w-auto object-contain transition-opacity duration-200" data-id="element-158" />
            </a>
          </div>

          {/* Desktop Actions */}
          <div className="hidden md:flex items-center space-x-4" data-id="element-159">
            <button onClick={toggleLanguage} className={`flex items-center gap-1 text-sm font-medium px-3 py-2 rounded-full border transition-colors ${isScrolled ? 'text-text-muted hover:text-text-main border-gray-200 hover:border-gray-300' : 'text-white/90 hover:text-white border-white/30 hover:border-white/60'}`} data-id="element-160">
              <Globe size={16} data-id="element-161" />
              <span data-id="element-162">{language.toUpperCase()}</span>
            </button>
            <a href="https://tokoteta.id/auth/register" className="bg-primary hover:bg-primary-hover text-white text-sm font-semibold px-6 py-2.5 rounded-full transition-all shadow-md hover:shadow-lg transform hover:-translate-y-0.5" data-id="element-163">
              {t.header.joinUs}
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button className={`md:hidden p-2 ${isScrolled ? 'text-text-main' : 'text-white'}`} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-164">
            {isMobileMenuOpen ? <X size={24} data-id="element-165" /> : <Menu size={24} data-id="element-166" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-167">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-gray-100 overflow-hidden" data-id="element-168">
            <div className="px-4 py-6 space-y-1" data-id="element-169">
              {navLinks.map(link => <a key={link.name} href={link.href} className="block text-base font-medium text-text-main hover:text-primary py-3 border-b border-gray-100 last:border-b-0" onClick={() => setIsMobileMenuOpen(false)} data-id="element-170">
                  {link.name}
                </a>)}
              <div className="pt-4 flex flex-col space-y-3" data-id="element-171">
                <button onClick={toggleLanguage} className="flex items-center justify-center gap-2 w-full py-2.5 border border-gray-200 rounded-lg text-text-main font-medium" data-id="element-172">
                  <Globe size={18} data-id="element-173" />
                  <span data-id="element-174">{language === 'en' ? 'English' : 'Indonesia'}</span>
                </button>
                <a href="https://tokoteta.id/auth/register" className="flex items-center justify-center w-full bg-primary text-white font-semibold py-3 rounded-lg shadow-md" data-id="element-175">
                  {t.header.joinUs}
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}